export const treatmentPlanLabels = {
  list: 'Treatment plan',
  create: 'Create new treatment plan',
  edit: 'Edit treatment plan',
  update: 'Update treatment plan',
  select: 'Select treatment plan',
  loadData: 'Load data in clinical note',
  selectUpdate: 'Select treatment plan to update'
};

export const deletedCptLoadNoteKeys = ['primary', 'secondary', 'tertiary', 'adjustment'];

export const categoryOrders = {
  hp: ['history', 'physical', 'assessment', 'plan'],
  soap: ['subjective', 'objective', 'assessment', 'plan']
};

export const notesWithCategories = ['hp', 'soap'];
